import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/visitPartsConstants';

const initialState = {
  visitParts: [],
  visitPart: null,
  loading: true,
  totalPrice: 0,
};

const visitPartsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VISIT_PARTS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_VISIT_PART:
      return {
        ...state,
        visitPart: null,
      };
    case types.GET_VISIT_PARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        visitParts: payload,
        totalPrice: payload.reduce((total, item) => {
          return total + item.price;
        }, 0),
      };
    case types.GET_VISIT_PARTS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VISIT_PARTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_VISIT_PART:
      return {
        ...state,
        visitPart: payload,
      };
    default:
      return state;
  }
};

export default visitPartsReducer;
